import { render, staticRenderFns } from "./SidebarPlcListItem.vue?vue&type=template&id=219fe0ec&"
import script from "./SidebarPlcListItem.vue?vue&type=script&lang=ts&"
export * from "./SidebarPlcListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports